/** 트레이닝 오버레이용 히트 로그·DPS·무적. 세이브에 넣지 않는다. */

export interface TrainHit {
  at: number;
  amount: number;
  name: string;
  crit: boolean;
  toPlayer: boolean;
}

const WINDOW_MS = 5000;
const MAX_LOG = 14;

class TrainingState {
  on = false;
  god = false;
  readonly log: TrainHit[] = [];

  toggle(): boolean {
    this.on = !this.on;
    if (!this.on) this.god = false;
    return this.on;
  }

  toggleGod(): boolean {
    this.god = !this.god;
    return this.god;
  }

  note(hit: Omit<TrainHit, 'at'>): void {
    this.log.unshift({ ...hit, at: performance.now() });
    if (this.log.length > MAX_LOG) this.log.pop();
  }

  dps(): number {
    const now = performance.now();
    let sum = 0;
    for (const h of this.log) {
      if (now - h.at > WINDOW_MS) break;
      if (!h.toPlayer) sum += h.amount;
    }
    return sum / (WINDOW_MS / 1000);
  }
}

export const training = new TrainingState();
